import { render } from "./CollectionEntry.vue?vue&type=template&id=840d8240&ts=true"
import script from "./CollectionEntry.vue?vue&type=script&lang=ts"
export * from "./CollectionEntry.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__